import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MiniProgress',
  props: {
    target: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 10
    },
    color: {
      type: String,
      default: '#13C2C2'
    },
    percentage: {
      type: Number,
      default: 0
    }
  }
};